module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/logo-coj-zh-hant-7065c9458d2e0d15eaf1602b0c938de7.svg";